import { useWatch } from "react-hook-form";

/**
 * Returns whether the current cell should display "N/A" instead of its input.
 *
 * A cell opts into this behaviour by having an `NA` property (comma-separated
 * list of controlling-cell keys, e.g. `"3,4"`). The controlling cell is the
 * sibling column that carries `feature: "NACellByClass"`.
 *
 * @param cellNA - The `NA` property of the current cell (e.g. `"3,4"`).
 * @param currentCols - All sibling columns in the same row.
 */
const useNACellByClass = (
  cellNA: string | undefined,
  currentCols: Record<string, any>,
): boolean => {
  const naCellByClassCol = cellNA
    ? Object.entries(currentCols).find(
        ([, col]: [any, any]) => col.feature === "NACellByClass",
      )
    : undefined;

  const naCellByClassUuid = naCellByClassCol
    ? naCellByClassCol[0]
    : "NA_CELL_BY_CLASS_CHECK";

  const naCellByClassValue = useWatch({
    name: naCellByClassUuid,
    disabled: !cellNA,
  });

  return (
    !!naCellByClassCol &&
    !!cellNA &&
    !!naCellByClassValue &&
    cellNA
      .split(",")
      .map(v => v.trim())
      .includes(String(naCellByClassValue?.key))
  );
};

export default useNACellByClass;
